import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    title: "Diagnóstico",
    desc: "Mapeamento dos processos, sistemas e gargalos com o time. Entrega: relatório executivo com priorização e ROI estimado.",
  },
  {
    n: "02",
    title: "Desenho",
    desc: "Arquitetura alvo, roadmap, seleção de ferramentas (RPA, low-code, IA) e definição de KPIs de sucesso.",
  },
  {
    n: "03",
    title: "Implementação",
    desc: "Squad enxuta, entregas incrementais e integração ao ERP. Compliance e auditoria embarcados desde o dia zero.",
  },
  {
    n: "04",
    title: "Autonomia",
    desc: "Capacitação prática do seu time em low-code, IA e vibe coding. Handover total — você fica dono da evolução.",
  },
];

export default function Methodology() {
  return (
    <section id="metodo" className="relative py-28 md:py-36" data-testid="methodology-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <p className="label-eyebrow">Metodologia</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-tight tracking-tight text-white">
            Um caminho <span className="gradient-text">testado</span> em multinacionais.
          </h2>
          <p className="mt-6 text-lg text-[#B8C0D0] leading-relaxed">
            Sem overhead, sem powerpoint infinito. Ciclos curtos, entregas medíveis e autonomia crescente para o seu time.
          </p>
        </div>

        <div className="mt-16 relative">
          {/* connector line */}
          <div className="absolute hidden md:block left-0 right-0 top-14 h-px bg-gradient-to-r from-transparent via-cyan-400/40 to-transparent" />

          <div className="grid md:grid-cols-4 gap-6" data-testid="methodology-steps">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="relative"
                data-testid={`method-step-${i}`}
              >
                <div className="w-28 h-28 mx-auto md:mx-0 rounded-2xl border border-cyan-400/25 bg-[#030B1E] flex items-center justify-center relative">
                  <span className="font-display font-black text-5xl text-cyan-400 glow-text">
                    {s.n}
                  </span>
                  <div className="absolute inset-0 rounded-2xl border border-cyan-400/40 animate-ping opacity-20" />
                </div>
                <h3 className="font-display text-2xl font-bold text-white mt-6">{s.title}</h3>
                <p className="mt-3 text-[#8892B0] leading-relaxed">{s.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
